import { generateTypes } from '../utils/HttpReducerHelper';

export const requestHelp = generateTypes('REQUEST_HELP', 'REQUEST_HELP');
export const requestHelpUpdate = generateTypes('REQUEST_HELP', 'REQUEST_HELP_UPDATE');
